import React from "react";
import PropTypes from 'prop-types';
import { PrimaryButton } from "../.."; // eslint-disable-line import/no-cycle
import { WHITE, GREY_GAME_EVENT_DIVIDER, GREEN_LIGHT } from '../../styles/shared/colors';
import "./HeatMapFilters.scss";

const HeatMapFilters = ({ filters, onItemClick, activeFilter }) => {
  const sortedFilters = filters.sort((a,b)=>{
    if (a.shortcut < b.shortcut)
    return -1;
  if (a.shortcut > b.shortcut)
    return 1;
  return 0;
  });

  return (
    <div className="heat-map-filters">
      {sortedFilters.map(filter => (
        <PrimaryButton
          key={filter.shortcut}
          className='heat-map-filters__button'
          style={{ fontSize: filter.shortcut.length > 7 ? '12px' : '14px' }}
          color={WHITE}
          background={activeFilter.includes(filter.shortcut) ? GREEN_LIGHT : GREY_GAME_EVENT_DIVIDER}
          onClick={()=> onItemClick(filter.shortcut)}
        >
          <div
            className="heat-map-filters__button__dot"
            style={{ backgroundColor: filter.markerColor }}
          />
          {filter.shortcut}
        </PrimaryButton>
      ))}
    </div>
  );
};

HeatMapFilters.propTypes = {
  activeFilter: PropTypes.array,
  filters: PropTypes.array,
  onItemClick: PropTypes.func
};

HeatMapFilters.defaultProps = {
  activeFilter: [],
  filters: [],
  onItemClick: ()=> {}
};

export default HeatMapFilters;
